// extracted by mini-css-extract-plugin
export var slider = "styles-module--slider--Nqgzd";
export var slide = "styles-module--slide--1uRp4";
export var listItem = "styles-module--listItem--tHPRL";